"use client";
import { createContext, useState } from "react";

export const AuthUserContext = createContext<any>({})